import React, { useEffect } from "react";

import { THEME, ThemeProvider } from "App/common/ThemeProvider";
import { RefreshAppBanner } from "App/common/banners/RefreshAppBanner/RefreshAppBanner";
import { UserDeletionInProgressBanner } from "App/common/banners/UserDeletionInProgressBanner/UserDeletionInProgressBanner";
import { useViewport } from "App/common/useViewport";
import { useAuth } from "App/components/Auth";
import { routePaths } from "App/modules/urls";
import { matchAppPath } from "App/modules/utils";
import { useUrlContext } from "App/routes/Main/useUrlContext";
import { useIntercomContext } from "App/services/intercom/IntercomContext";
import { useGlobalAudioPlayer, useHTMLAudioPlayer } from "../GlobalAudioPlayer";
import { SIDEBAR_ID, SIDEBAR_SIDE, SIDEBAR_TYPE } from "../Sidebar";
import { SidebarContextProvider, WithSidebar } from "../Sidebar/Sidebar";
import { MainWidthProvider } from "./useMainWidth";

import "./Layout.scss";

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const { isActive } = useGlobalAudioPlayer();
  const { useHTMLPlayer, isActive: isHTMLPlayerActive } = useHTMLAudioPlayer();
  const { user } = useAuth();
  const isLoggedIn = !!user;
  const { isMaxViewportL } = useViewport();
  const { setIsGlobalAudioPlayerActive } = useIntercomContext();
  const { viewAsTrackStory } = useUrlContext();

  const isGlobalAudioPlayerActive = useHTMLPlayer
    ? isHTMLPlayerActive
    : isActive;

  useEffect(() => {
    setIsGlobalAudioPlayerActive(isGlobalAudioPlayerActive);
  }, [isGlobalAudioPlayerActive]);

  const hideSideBar = Boolean(
    matchAppPath(routePaths.dropboxLogin) ||
      matchAppPath(routePaths.dropboxClone) ||
      matchAppPath(routePaths.dropboxCallback) ||
      matchAppPath(routePaths.trackstories) ||
      matchAppPath(routePaths.submit) ||
      viewAsTrackStory,
  );

  return (
    <ThemeProvider theme={THEME.DARK}>
      <div
        className="highnote-layout-with-navigation"
        data-is-anon={!isLoggedIn}
      >
        <SidebarContextProvider
          forceClose={hideSideBar}
          ids={[SIDEBAR_ID.GLOBAL_NAV]}
          ignoreUrl
        >
          <WithSidebar
            side={SIDEBAR_SIDE.LEFT}
            type={SIDEBAR_TYPE.PUSH}
            resizable
          >
            <MainWidthProvider className="highnote-layout">
              <SidebarContextProvider
                ids={isMaxViewportL ? [SIDEBAR_ID.SPACE_CHAT] : []}
              >
                <WithSidebar side={SIDEBAR_SIDE.RIGHT} type={SIDEBAR_TYPE.PUSH}>
                  <UserDeletionInProgressBanner />
                  <RefreshAppBanner />
                  {children}
                </WithSidebar>
              </SidebarContextProvider>
            </MainWidthProvider>
          </WithSidebar>
        </SidebarContextProvider>
      </div>
    </ThemeProvider>
  );
};
